<template>
  <div class="nav_header_container">
    <div class="logo">
      <Logo v-if="showLogo" :collapse="false" />
    </div>
    <div class="menu">
      <el-menu
        :default-active="activeMenu"
        class="el-menu-demo"
        mode="horizontal"
        :collapse="isCollapse"
        background-color="#2b2f3a"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
      >
        <div class="routeMenu" v-for="route in oneRoute" :key="route.id">
          <template v-if="!route.hidden">
            <div class="routeItem" :style="isActive(route)" @click="changeMenu(route.path)">
              <item :title="route.title" />
            </div>
          </template>
        </div>
      </el-menu>
    </div>
    <right-menu></right-menu>
  </div>
</template>

<script>
import Logo from "../Sidebar/Logo";
import { mapGetters } from "vuex";
import Item from "./Item";
import variables from "@/styles/variables.scss";

import RightMenu from '../RightMenu'
export default {
  components: { Logo, Item, RightMenu },
  data() {
    this.onlyOneChild = null;
    return {
    };
  },
  mounted () {
    let defaultPath = '/' + this.$route.path.split('/')[1]
    this.changeMenu(defaultPath)
  },
  methods: {
    // 菜单切换
    changeMenu(id){
      this.$store.commit('permission/SET_ROUTE_ID',id)
    },
    isActive(route){
      if(this.route_id === '/statistical-analysis' || this.route_id === '/dashboard'){
        if(route.path === '/'){
          route.path = this.route_id
        }
      }
      return route.path === this.route_id ? 'color:#fff;background-color:#596677' : ''
    }
  },
  computed: {
    ...mapGetters(["permission_routes", "sidebar","route_id","avatar","device","showSettings","theme","sidebarView"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
    oneRoute(){
      let r = this.permission_routes.map(item=>{
        if(!item.hidden){
            return {title:item.meta.title,id:item.id,icon:item.meta.icon,path:item.path}
        }
      }).filter(Boolean)
      return r
    }
  },
};
</script>

<style scoped lang="scss">
.routeMenu{
  height: 50px;
  line-height: 50px;
  .routeItem{
    width: 100px;
    color: #929292;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }
}
.nav_header_container {
  width: 100%;
  height: 50px;
  display: flex;
  background-color:#2b2f3a;
  position: fixed;
  top: 0;
  z-index: 999;
  .logo {
    width: 210px;
    height: 50px;
  }
  .menu {
    width: 100%;
    flex: 1;
    position: relative;
    z-index: -222;
    .el-menu--horizontal {
      display: flex;
    }
  }
}
</style>
